<ng-container *transloco="let t">
  <div [formGroup]="form" class="owner-statement-dental-treatment">
    <h3 class="mb-2">{{ t('Consent for Dental Treatment / Procedure') }}</h3>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Notes and instructions') }}</mat-label>
      <textarea matInput formControlName="note" rows="4"></textarea>
    </mat-form-field>

    <div class="grid grid-cols-2 gap-3 mb-2">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Estimated costs from') }}</mat-label>
        <input matInput formControlName="estimatedCostFrom" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Estimated costs to') }}</mat-label>
        <input matInput formControlName="estimatedCostTo" />
      </mat-form-field>
    </div>

    <div class="grid grid-cols-2 gap-3 mb-3">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Additional costs from') }}</mat-label>
        <input matInput formControlName="additionalCostFrom" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Additional costs to') }}</mat-label>
        <input matInput formControlName="additionalCostTo" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
